export * from './form-search-patient/form-search-patient.component';
